import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

import Dropdown from "@trendmicro/react-dropdown";
import "@trendmicro/react-buttons/dist/react-buttons.css";
import "@trendmicro/react-dropdown/dist/react-dropdown.css";
import anchorme from "anchorme";

import {
  CHALLENGE,
  CHALLENGE_ENQUIRY,
  CHALLENGE_COMMENTS,
  CHALLENGE_A_FRIEND,
  TOPIC
} from "App/Routes";
import LoginDialogContainer from "components/shared/Dialogs/LoginDialog/LoginDialogContainer";
import ImageDialog from "components/shared/Dialogs/ImageDialog/ImageDialog";
import EmbedDialog from "components/shared/Dialogs/EmbedDialog/EmbedDialog";
import ClaimForm from "./ClaimForm/ClaimForm";
import ChallengeResult from "./ChallengeResult/ChallengeResult";
import LocationMap from "./LocationMap";
import Link from "components/shared/Link/Link";
import GenericErrorPage from "components/ErrorPages/GenericError/GenericErrorPage";
import YoutubePlayer from "components/shared/YoutubePlayer/YoutubePlayer";
import "./Challenge.css";

import {
  USE_ENQUIRY_PAGE,
  CONTACT_EMAIL_DEFAULT,
  CONTACT_EMAIL_TITLE_DEFAULT,
  ENABLE_CHALLENGE_COMMENTS,
  ENABLE_CHALLENGE_BOOKMARK_BUTTON,
  ENABLE_CHALLENGE_LIKES,
  SESSION_KEY_PARAMETER_APPENDED
} from "config";
import deviceServices from "services/deviceServices";
import localize from "lang/localize";

const propTypes = {
  user: PropTypes.object.isRequired,
  sessionKey: PropTypes.string,
  challengeTypeId: PropTypes.number.isRequired,
  isConfirmationChallenge: PropTypes.bool,
  photoRequired: PropTypes.bool,
  noPhoto: PropTypes.bool,
  quizOptions: PropTypes.array,
  privateClaim: PropTypes.bool,
  fields: PropTypes.array,
  completionMessage: PropTypes.string,
  multiSelect: PropTypes.bool,
  claimed: PropTypes.bool,
  claimedBefore: PropTypes.bool,
  expired: PropTypes.bool.isRequired,
  submitted: PropTypes.bool.isRequired,
  videoDurationLimit: PropTypes.number,
  // location
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  addressFormatted: PropTypes.string,
  // challengeresult
  id: PropTypes.number.isRequired,
  correctAnswerNo: PropTypes.number,
  wrongAnswerNo: PropTypes.number,
  correctAnswerTitle: PropTypes.string,
  correctAnswer: PropTypes.bool,
  // image
  imageMedium: PropTypes.string,
  // embed
  medias: PropTypes.array,
  // text
  footnote: PropTypes.string,
  title: PropTypes.string,
  repeat: PropTypes.bool,
  repeatUntilCorrect: PropTypes.bool,
  repeatAtFormatted: PropTypes.string,
  videoDurationLimitFormatted: PropTypes.string,
  // stats
  commentNo: PropTypes.number,
  claimNo: PropTypes.number,
  previousChallengeId: PropTypes.number,
  nextChallengeId: PropTypes.number,
  challengeType: PropTypes.string.isRequired,
  points: PropTypes.number.isRequired,
  challengeReferralLink: PropTypes.string,
  isLiked: PropTypes.bool.isRequired,
  likeNo: PropTypes.number.isRequired,
  isBookmarked: PropTypes.bool.isRequired,
  handleBookmark: PropTypes.func.isRequired,
  handleLike: PropTypes.func.isRequired,
  postClaim: PropTypes.func.isRequired,
  postQRClaim: PropTypes.func.isRequired,
  showAlertWithTimeout: PropTypes.func,
  adminToClaim: PropTypes.bool.isRequired,
  // login dialogs
  showClaimLoginDialog: PropTypes.bool.isRequired,
  handleOpenClaimLoginDialog: PropTypes.func.isRequired,
  handleCloseClaimLoginDialog: PropTypes.func.isRequired,
  showBookmarkLoginDialog: PropTypes.bool.isRequired,
  handleOpenBookmarkLoginDialog: PropTypes.func.isRequired,
  handleCloseBookmarkLoginDialog: PropTypes.func.isRequired,
  showLikeLoginDialog: PropTypes.bool.isRequired,
  handleOpenLikeLoginDialog: PropTypes.func.isRequired,
  handleCloseLikeLoginDialog: PropTypes.func.isRequired,
  // image dialogs
  showImageDialog: PropTypes.bool.isRequired,
  handleOpenImageDialog: PropTypes.func.isRequired,
  handleCloseImageDialog: PropTypes.func.isRequired,
  // embed dialogs
  showEmbedDialog: PropTypes.bool.isRequired,
  handleOpenEmbedDialog: PropTypes.func.isRequired,
  handleCloseEmbedDialog: PropTypes.func.isRequired,
  // qr dialogs
  showQRModal: PropTypes.bool,
  handleOpenQRModal: PropTypes.func,
  handleCloseQRModal: PropTypes.func,
  // language
  language: PropTypes.string,
  // contact email
  contactEmail: PropTypes.string,
  // locked content handling
  locked: PropTypes.bool,
  lockedChallengeTopicId: PropTypes.number,
  lockedChallengeTopicTitle: PropTypes.string,
  // project and topic information
  project: PropTypes.object,
  topic: PropTypes.object
};

const defaultProps = {
  contactEmail: CONTACT_EMAIL_DEFAULT
};

class ChallengePage extends Component {
  getFirstEmbeddableItem() {
    return this.props.medias.filter(media => media.source === "Embed")[0];
  }

  renderChallengeInfo() {
    if (this.props.locked) {
      return (
        <div className="pure-g innerblock">
          <div className="pure-u-2-24">
            {this.renderPreviousChallengeButton()}
          </div>
          <div className="pure-u-20-24 topmargin-30">
            <GenericErrorPage
              routeUrl={TOPIC.format(this.props.lockedChallengeTopicId)}
              routeName={"“" + this.props.lockedChallengeTopicTitle + "”"}
              message={localize(
                "locked_challenge_with_route",
                this.props.language
              ).format(this.props.lockedChallengeTopicTitle)}
              language={this.props.language}
            />
          </div>
          <div className="pure-u-2-24">{this.renderNextChallengeButton()}</div>
        </div>
      );
    } else {
      return (
        <div className="pure-g innerblock">
          <div className="pure-u-2-24">
            {this.renderPreviousChallengeButton()}
          </div>
          <div className="pure-u-20-24">
            <div className="pure-u-1 pure-u-md-8-24 relative">
              {this.renderMedia()}
            </div>
            <div className="pure-u-md-1-24" />
            <div className="pure-u-1 pure-u-md-15-24 topmargin-10">
              {this.renderText()}
              {this.renderStats()}
              {this.renderButtons()}
            </div>
          </div>
          <div className="pure-u-2-24">{this.renderNextChallengeButton()}</div>
        </div>
      );
    }
  }

  renderPreviousChallengeButton() {
    /* Previous Challenge exists, and previous Challenge is not locked */
    if (this.props.previousChallengeId) {
      return (
        <Link
          className="challenge-nav floatright"
          to={CHALLENGE.format(this.props.previousChallengeId)}
        >
          <i className="fas fa-arrow-circle-left"></i>
        </Link>
      );
    } else {
      /* Previous Challenge does not exist */
      return null;
    }
  }

  renderNextChallengeButton() {
    /* Next Challenge exists, and next Challenge is not locked */
    if (this.props.nextChallengeId) {
      return (
        <Link
          className="challenge-nav floatleft"
          to={CHALLENGE.format(this.props.nextChallengeId)}
        >
          <i className="fas fa-arrow-circle-right"></i>
        </Link>
      );
    } else {
      /* Next Challenge does not exist */
      return null;
    }
  }

  renderMedia() {
    let hasEmbed = this.checkEmbed();

    return (
      <div className={hasEmbed ? "topmargin-30 relative" : ""}>
        <div
          className={"challenge-icons-position " + (hasEmbed && "has-embed")}
        >
          <div
            className={
              "challengeicon icon " +
              (this.props.isConfirmationChallenge
                ? "confirmation"
                : this.props.challengeType)
            }
          />
          {this.props.points !== 0 ? (
            <div className="challengeicon">
              <div className="points">
                +{this.props.points.abbreviateNumber()}
              </div>
            </div>
          ) : null}
        </div>
        {this.renderEmbed()}
      </div>
    );
  }

  checkEmbed() {
    let embeddable = this.getFirstEmbeddableItem();

    /*
      For external challenges (challengeTypeId 15),
      we won't be rendering the embedded files like
      typical PDF or video embeds.
    */
    if (embeddable && this.props.challengeTypeId !== 15) {
      return true;
    } else {
      return false;
    }
  }

  renderEmbed() {
    let embeddable = this.getFirstEmbeddableItem();

    if (
      embeddable &&
      this.props.challengeTypeId !== 15 &&
      embeddable.url.indexOf("https://") === 0
    ) {
      switch (embeddable.type) {
        case "Video":
          return this.renderVideo(embeddable);
        case "PDF":
          return this.renderPdf(embeddable);
        case "Youtube":
          return this.renderYoutube(embeddable);
        // case "Youtube":
        case "Vimeo":
          return this.renderYoutubeVimeo(embeddable);
        case "SoundCloud":
          /* SoundCloud embed turned off temporarily until client key is given */
          return this.renderImg();
        case "Others":
          return this.renderOthers(embeddable);
        default:
          return this.renderImg();
      }
    } else {
      return this.renderImg();
    }
  }

  renderImg() {
    let imageMedium = this.props.imageMedium;

    return (
      <div>
        <span className="square-image-wrapper">
          <span
            className="square-image challenge-image"
            onClick={this.props.handleOpenImageDialog}
          >
            <img src={imageMedium} alt="" />
          </span>
        </span>
        {this.props.showImageDialog && this.renderImageDialog()}
      </div>
    );
  }

  renderVideo(embed) {
    let displayUrl = embed.displayUrl;
    let url =
      embed.url + SESSION_KEY_PARAMETER_APPENDED + this.props.sessionKey;

    return (
      <div
        key={displayUrl}
        className={
          "iframe-container-challenge-profile bottommargin" +
          (deviceServices.isIOS() ? " iframe-scroll-wrapper" : "")
        }
      >
        <iframe title={displayUrl} src={url} allowFullScreen />
      </div>
    );
  }

  renderYoutube(embed) {
    const YOUTUBE_ID = embed.displayUrl.slice(17);

    return (
      <YoutubePlayer
        id={YOUTUBE_ID}
        user={this.props.user}
        contentId={this.props.id}
        contentTitle={this.props.title}
        project={this.props.project}
        topic={this.props.topic}
      />
    );
  }

  renderYoutubeVimeo(embed) {
    let displayUrl = embed.displayUrl;
    let url = embed.url;

    return (
      <div
        className={
          "iframe-container-challenge-profile" +
          (deviceServices.isIOS() ? " iframe-scroll-wrapper" : "")
        }
      >
        <iframe
          title={displayUrl}
          src={url} // use url for Youtube and Vimeo to avoid X-Frame-Options: sameorigin problems
          allowFullScreen
        />
      </div>
    );
  }

  renderPdf(embed) {
    let displayUrl = embed.displayUrl;
    let url = embed.url;

    /*
      in the past, we use the "?.pdf" hack appended at the back of links
      to render websites when website embed wasn't available. to allow such
      embeds to continue being loaded seamlessly, we catch them by checking for "?.pdf"
      filetypes and forcing it into this.renderOthers();
    */
    if (embed.url.indexOf("?.pdf") !== -1) {
      return this.renderOthers(embed);
    } else {
      return (
        <div
          className={
            "iframe-container-challenge-profile-pdf" +
            (deviceServices.isIOS() ? " iframe-scroll-wrapper" : "")
          }
        >
          <iframe
            src={"https://docs.google.com/viewer?url=" + url + "&embedded=true"}
            title={displayUrl}
            allowFullScreen
            width="100%"
          />
        </div>
      );
    }
  }

  renderOthers(embed) {
    let displayUrl = embed.displayUrl;
    let url = embed.url;

    /* hides iframe, replace with black background */
    if (this.props.showEmbedDialog) {
      return (
        <div
          className={
            "iframe-container-challenge-profile" +
            (deviceServices.isIOS() ? " iframe-scroll-wrapper" : "")
          }
        >
          {this.renderEmbedDialog(embed.url)}
        </div>
      );
    } else {
      /* shows iframe in challenge profile */
      return (
        <div
          className={
            "iframe-container-challenge-profile" +
            (deviceServices.isIOS() ? " iframe-scroll-wrapper" : "")
          }
        >
          <button
            className="button icon"
            onClick={this.props.handleOpenEmbedDialog}
          >
            <span className="expand-icon" />
          </button>
          <iframe
            title={displayUrl}
            src={url}
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          />
        </div>
      );
    }
  }

  addAnchors(text) {
    // add anchor tags to links
    if (text) {
      text = anchorme(text, {
        exclude: urlObj => {
          urlObj.encoded = urlObj.encoded.replace(/%25/g, "%");
          return false;
        },
        attributes: [
          { name: "target", value: "blank" },
          { name: "class", value: "link default break-url" },
          { name: "rel", value: "external" }
        ]
      });
    }
    return text;
  }

  renderText() {
    let footnoteAnchored = this.addAnchors(this.props.footnote);
    let titleAnchored = this.addAnchors(this.props.title);

    return (
      <div>
        <h5 dangerouslySetInnerHTML={{ __html: titleAnchored }} />
        <p dangerouslySetInnerHTML={{ __html: footnoteAnchored }} />
        <p className="smalltext topmargin-30">
          {this.getRepeatText(this.props.repeat)}
          {this.getVideoDurationLimitText()}
        </p>
        <hr className="bottommargin-30 topmargin-30" />
      </div>
    );
  }

  getRepeatText(repeat: boolean) {
    if (this.props.challengeTypeId === 4) {
      return null;
    }

    /* passcode/fixed answer challenge */
    if (this.props.challengeTypeId === 9) {
      return localize(
        "challenge_profile_repeat_once_text",
        this.props.language
      );
    }

    if (this.props.repeatUntilCorrect) {
      return localize(
        "challenge_profile_repeat_again_text",
        this.props.language
      );
    } else if (!repeat) {
      return localize(
        "challenge_profile_repeat_once_text",
        this.props.language
      );
    } else if (this.props.repeatAtFormatted) {
      return localize(
        "challenge_profile_repeat_again_text_with_duration",
        this.props.language
      ).format(this.props.repeatAtFormatted);
    } else {
      return localize(
        "challenge_profile_repeat_again_text",
        this.props.language
      );
    }
  }

  getVideoDurationLimitText() {
    if (this.props.videoDurationLimitFormatted) {
      return (
        <Fragment>
          <br />
          {localize(
            "challenge_profile_max_duration_text",
            this.props.language
          ).format(this.props.videoDurationLimitFormatted)}
        </Fragment>
      );
    }
  }

  renderStats() {
    if (
      this.props.challengeTypeId === 4 &&
      (ENABLE_CHALLENGE_LIKES || ENABLE_CHALLENGE_COMMENTS)
    ) {
      return (
        <p className="smalltext">
          {ENABLE_CHALLENGE_COMMENTS
            ? this.props.commentNo.pluralize(
                localize("comment_text", this.props.language),
                localize("comments_text", this.props.language)
              )
            : null}
          {/* rendering spaces below, &nbsp; doesn't render well with JSX */}
          {ENABLE_CHALLENGE_COMMENTS & ENABLE_CHALLENGE_LIKES
            ? "\u00A0\u00A0\u00A0"
            : null}
          {ENABLE_CHALLENGE_LIKES
            ? this.props.likeNo.pluralize(
                localize("like_text", this.props.language),
                localize("likes_text", this.props.language)
              )
            : null}
        </p>
      );
    } else if (this.props.challengeTypeId === 4) {
      return null;
    } else if (ENABLE_CHALLENGE_COMMENTS) {
      return (
        <p className="smalltext">
          {this.props.commentNo.pluralize(
            localize("comment_text", this.props.language),
            localize("comments_text", this.props.language)
          )}
          &nbsp;&nbsp;&nbsp;
          {localize("challenge_completed_text", this.props.language).format(
            this.props.claimNo
          )}
        </p>
      );
    } else {
      return (
        <p className="smalltext">
          {localize("challenge_completed_text", this.props.language).format(
            this.props.claimNo
          )}
        </p>
      );
    }
  }

  renderActionButton() {
    if (this.props.challengeTypeId === 4) {
      return null;
    }
    if (this.props.expired) {
      return (
        <button id="cta" className="button inline float-right inactive">
          {localize("button_challenge_challenge_expired", this.props.language)}
        </button>
      );
    } else if (this.props.claimed) {
      return (
        <button id="cta" className="button inline float-right inactive">
          {localize(
            "button_challenge_challenge_completed",
            this.props.language
          )}
        </button>
      );
    } else if (this.props.adminToClaim) {
      return null;
    } else {
      return null;
    }
  }

  renderChallengeCommentsButton() {
    if (ENABLE_CHALLENGE_COMMENTS) {
      return (
        <Link
          to={CHALLENGE_COMMENTS.format(this.props.id)}
          id="commentButton"
          className="button icon inline-block"
        >
          <span className="comment-icon" />
        </Link>
      );
    } else {
      return null;
    }
  }

  renderButtons() {
    return (
      <div>
        {this.renderBookmarkButton()}
        {this.props.challengeTypeId === 4 && this.renderLikeButton()}
        {this.renderChallengeCommentsButton()}
        {this.renderMenuDropdownButton()}
        <div className="topmargin-10">{this.renderActionButton()}</div>
      </div>
    );
  }

  renderMenuDropdownButton() {
    if (this.props.sessionKey) {
      return (
        <div className="dropdown-button-group">
          <Dropdown
            dropup={true}
            onSelect={(eventKey, event) => {
              event.preventDefault();
            }}
            pullRight={true}
          >
            <Dropdown.Toggle
              btnStyle="flat"
              noCaret={true}
              onClick={e => {
                e.preventDefault();
              }}
            >
              <span className="more-icon" />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {this.props.challengeReferralLink ? (
                <Link to={CHALLENGE_A_FRIEND.format(this.props.id)}>
                  {localize("challenge_referral_text", this.props.language)}
                </Link>
              ) : null}
              {USE_ENQUIRY_PAGE ? (
                <Link to={CHALLENGE_ENQUIRY.format(this.props.id)}>
                  {localize("report_challenge", this.props.language)}
                </Link>
              ) : (
                <a
                  href={
                    "mailto:" +
                    this.props.contactEmail +
                    "?subject=" +
                    (CONTACT_EMAIL_TITLE_DEFAULT
                      ? CONTACT_EMAIL_TITLE_DEFAULT
                      : "I want to make a report on Gametize (Challenge ID: " +
                        this.props.id +
                        ")")
                  }
                >
                  {localize("report_challenge", this.props.language)}
                </a>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      );
    } else {
      return null;
    }
  }

  renderBookmarkButton() {
    if (!ENABLE_CHALLENGE_BOOKMARK_BUTTON) {
      return null;
    } else if (!!this.props.user.id) {
      return (
        <button
          id="bookmarkButton"
          className={
            "button icon inline" +
            (this.props.isBookmarked ? " bookmarked" : "")
          }
          onClick={event =>
            this.props.handleBookmark(
              event,
              this.props.id,
              this.props.isBookmarked
            )
          }
        >
          <span className="bookmark-icon" />
        </button>
      );
    } else {
      return (
        <div className="inline">
          <button
            id="loginBeforeBookmarkButton"
            className={
              "button icon inline" +
              (this.props.isBookmarked ? " bookmarked" : "")
            }
            onClick={this.props.handleOpenBookmarkLoginDialog}
          >
            <span className="bookmark-icon" />
          </button>
          {this.props.showBookmarkLoginDialog &&
            this.renderBookmarkLoginDialog()}
        </div>
      );
    }
  }

  renderLikeButton() {
    if (!ENABLE_CHALLENGE_LIKES) {
      return null;
    } else if (!!this.props.user.id) {
      return (
        <button
          id="likeButton"
          className={
            "button icon inline" + (this.props.isLiked ? " liked" : "")
          }
          onClick={this.props.handleLike}
        >
          <span className="like-icon" />
        </button>
      );
    } else {
      return (
        <div className="inline">
          <button
            id="loginBeforeLikeButton"
            className={
              "button icon inline" + (this.props.isLiked ? " liked" : "")
            }
            onClick={this.props.handleOpenLikeLoginDialog}
          >
            <span className="like-icon" />
          </button>
          {this.props.showLikeLoginDialog && this.renderLikeLoginDialog()}
        </div>
      );
    }
  }

  renderBookmarkLoginDialog() {
    return (
      <LoginDialogContainer
        showModal={this.props.showBookmarkLoginDialog}
        handleCloseLoginDialog={this.props.handleCloseBookmarkLoginDialog}
        type="bookmark"
      />
    );
  }

  renderLikeLoginDialog() {
    return (
      <LoginDialogContainer
        showModal={this.props.showLikeLoginDialog}
        handleCloseLoginDialog={this.props.handleCloseLikeLoginDialog}
        type="like"
      />
    );
  }

  renderClaimLoginDialog() {
    return (
      <LoginDialogContainer
        showModal={this.props.showClaimLoginDialog}
        handleCloseLoginDialog={this.props.handleCloseClaimLoginDialog}
        type="claim"
      />
    );
  }

  renderImageDialog() {
    return (
      <ImageDialog
        showModal={this.props.showImageDialog}
        handleCloseImageDialog={this.props.handleCloseImageDialog}
        img={this.props.imageMedium}
      />
    );
  }

  renderEmbedDialog(url) {
    return (
      <EmbedDialog
        showDialog={this.props.showEmbedDialog}
        handleCloseEmbedDialog={this.props.handleCloseEmbedDialog}
        url={url}
        title={this.props.title}
      />
    );
  }

  render() {
    return (
      <div className="challenge">
        <div className="container verticalpadding">
          {this.renderChallengeInfo()}
        </div>
        <ClaimForm
          sessionKey={this.props.sessionKey}
          isLoggedIn={!!this.props.user.id}
          challengeTypeId={this.props.challengeTypeId}
          challengeId={this.props.id}
          isConfirmationChallenge={this.props.isConfirmationChallenge}
          photoRequired={this.props.photoOnly}
          noPhoto={this.props.noPhoto}
          quizOptions={this.props.quizOptions}
          fields={this.props.fields}
          completionMessage={this.props.completionMessage}
          multiSelect={this.props.multiSelect}
          claimed={this.props.claimed}
          postClaim={this.props.postClaim}
          postQRClaim={this.props.postQRClaim}
          showAlertWithTimeout={this.props.showAlertWithTimeout}
          adminToClaim={this.props.adminToClaim}
          expired={this.props.expired}
          submitted={this.props.submitted}
          videoDurationLimit={this.props.videoDurationLimit}
          videoDurationLimitFormatted={this.props.videoDurationLimitFormatted}
          externalEmbeddable={this.getFirstEmbeddableItem()}
          handleOpenClaimLoginDialog={this.props.handleOpenClaimLoginDialog}
          showQRModal={this.props.showQRModal}
          handleOpenQRModal={this.props.handleOpenQRModal}
          handleCloseQRModal={this.props.handleCloseQRModal}
          nextChallengeId={this.props.nextChallengeId}
          language={this.props.language}
        />
        {this.props.showClaimLoginDialog && this.renderClaimLoginDialog()}
        <LocationMap
          latitude={this.props.latitude}
          longitude={this.props.longitude}
          addressFormatted={this.props.addressFormatted}
          language={this.props.language}
        />
        <ChallengeResult
          id={this.props.id}
          userName={this.props.user.name}
          userPhoto={this.props.user.photoSmall}
          challengeTypeId={this.props.challengeTypeId}
          claimed={!!this.props.claimed}
          claimedBefore={!!this.props.claimedBefore}
          repeatUntilCorrect={this.props.repeatUntilCorrect}
          correctAnswerNo={this.props.correctAnswerNo}
          wrongAnswerNo={this.props.wrongAnswerNo}
          correctAnswerTitle={this.props.correctAnswerTitle}
          correctAnswer={this.props.correctAnswer}
          quizOptions={this.props.quizOptions}
          privateClaim={this.props.privateClaim}
          language={this.props.language}
        />
        {/* Added padding for floating buttons */}
        <div className="container bottompadding-floating" />
      </div>
    );
  }
}

ChallengePage.propTypes = propTypes;
ChallengePage.defaultProps = defaultProps;

export default ChallengePage;
